export const LOG_TYPE = {
  "CONFIRM_BILLING": "Konfirmasi Billing",
  "REVERT_BILLING": "Pengembalian Status Billing",
  "CHANGE_PACKAGE": "Pengajuan Ubah Paket",
  "CHANGE_DUE_DATE": "Pengubahan Jatuh Tempo",
  "RELOCATE": "Permintaan Relokasi",
  "DISMANTLE": "Permintaan Dismantle",
  "CREATE_BILLING": "Pembuatan Billing",
  "REGISTER": "Pendaftaran",
  "COVERAGE": "Pengecekan Coverage",
  "UPDATE_REGISTRATION": "Pengubahan Data Registrasi",
  "UPDATE_CUSTOMER": "Pengubahan Data Pelanggan",
  "UPDATE_REGISTRATION_SCHEDULE": "Pengubahan Data Penjadwalan",
  "UPDATE_BILLING": "Ubah Data Billing",
  "ACTIVATION_AUTOMATION": "Aktivasi Otomatis",
  "CHANGE_MODEM_AUTOMATION": "Ubah Modem Otomatis",
  "REBOOT_AUTOMATION": "Restart Modem melalui Sistem",
  "TERMINATE_AUTOMATION": "Terminate Modem melalui Sistem",
  "SOFT_BLOCK_AUTOMATION": "Soft Block Automation",
  "OPEN_SOFT_BLOCK_AUTOMATION": "Open Soft Block Automation",
  "CHANGE_PACKAGE_AUTOMATION": "Ubah Paket di Sistem Otomatis",
  "ACTIVATE_PROVISIONING_REQUEST": "Permintaan Aktivasi Partner Infra",
  "CHANGE_MODEM_PROVISIONING_REQUEST": "Permintaan Ganti Modem Partner Infra",
  "TERMINATE_MODEM_PROVISIONING_REQUEST": "Permintaan Terminate Modem Partner Infra",
  "BANDWITH_CHANGE_MUTATION": "Penggantian Bandwitdh Partner Infra",
  "ADDRESS_CHANGE_MUTATION": "Penggantian Alamat Partner Infra",
  "INSTALLATION_K3": "Dokumen K3 Instalasi Partner Infra",
  "ENABLE_SERVICE_MUTATION": "Open Isolir Layanan Partner Infra",
  "DISABLE_SERVICE_MUTATION": "Isolir Layanan Partner Infra",
  "ACCOUNT_CREATION": "Pembuatan Akun",
  "UPDATE_MODEM": "Update Data Modem",
  "MIGRATION_AUTOMATION": "Migrasi dengan Otomasi",
  "SKIP_TERMINATE_OLD_SN": "Skip terminate",
  "UNLINK_USER_MOBILE": "Unlink Pengguna MyViberlink"
};

export const ACS_ACTION_TYPES = [
  'ACTIVATION_AUTOMATION',
  'CHANGE_MODEM_AUTOMATION',
  'TERMINATE_AUTOMATION',
  'SOFT_BLOCK_AUTOMATION',
  'OPEN_SOFT_BLOCK_AUTOMATION',
  'CHANGE_PACKAGE_AUTOMATION',
  'MIGRATION_AUTOMATION'
];

export const ACS_LOG_TYPE = Object.fromEntries(
  ACS_ACTION_TYPES.map(key => [key, LOG_TYPE[key]])
);